import { render, staticRenderFns } from "./ApplyBottomButton.vue?vue&type=template&id=a83bd7c0&scoped=true"
import script from "./ApplyBottomButton.vue?vue&type=script&lang=js"
export * from "./ApplyBottomButton.vue?vue&type=script&lang=js"
import style0 from "./ApplyBottomButton.vue?vue&type=style&index=0&id=a83bd7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83bd7c0",
  null
  
)

export default component.exports